module.exports = __webpack_public_path__ + "static/media/right-arrow.9289cbd5.svg";